<template lang="pug">
  overlay.flex.overflow-y-scroll.scrolling-touch(v-on="$listeners", bg="app-bg", tabindex="0")
    .overlaymenu__body.md-flex.w-full.justify-center.my-auto.pt-100.pb-60.md-py-40
      //- (mobile header)
      h3.md-hidden.text-18.text-center.mb-30 Enquire
      //- image
      .md-w-1x2.lg-w-1x3.lg-mx-75.md-mb-0.flex.px-40.md-px-0
        figure.relative.w-full.pb-full.md-pb-0(v-if="details.image")
          resp-img(:src="details.image.url", :bg="true", bgClass="bg-contain bg-center bg-no-repeat", :useHeight="isPortrait(details.image)")
      //- text
      .w-full.max-w-400.mx-auto.lg-w-1x3.lg-mx-75.flex.flex-col.justify-between.px-15.md-pr-40.lg-px-20
        //- details
        header.w-full.text-center
          template(v-if="details.type === 'product'")
            h3.hidden.md-block.text-13.mb-12 Enquire
            .text-15.md-text-24.leading-lg.mt-30.md-mt-0(v-html="details.caption")
          template(v-else)
            h3.hidden.md-block.text-24.leading-none.mb-30 Enquire
            .text-15.md-text-17(v-html="details.caption")
        //- thank you msg
        .text-center(v-if="success")
          p.text-17.my-90
            | Thank you,<br>
            | A member of our team will be in touch with you soon.
          button.mx-auto.btn-theme-outlined(@click="$emit('close')")
            btn.min-w-btn-sm(theme="inherit") Close
        //- form
        .mt-40.md-mt-67(v-show="!success")
          //- (errors)
          .mb-24.text-center.text-app-accent.text-15.md-text-13(v-if="error") {{error}}
          //- fields
          form.flex.w-full.flex-col.justify-between(validate, @submit.prevent="submit")
            div.text-15.md-text-13
              div
                label.reader-show First Name
                input.block.w-full.border-b.py-15.md-py-6.px-10(ref="name", v-model="enquiry.first_name", type="text", placeholder="First Name")
              .md-mt-8
                label.reader-show Last Name
                input.block.w-full.border-b.py-15.md-py-6.px-10(v-model="enquiry.last_name", type="text", placeholder="Last Name")
              .md-mt-8
                label.reader-show Email
                input.block.w-full.border-b.py-15.md-py-6.px-10(v-model="enquiry.email", type="email", placeholder="Email", required)
              .md-mt-8
                label.reader-show Phone Number
                input.block.w-full.border-b.py-15.md-py-6.px-10(v-model="enquiry.tel", type="tel", placeholder="Phone Number")
              //- (comment)
              .md-mt-8.md--mb-40(v-if="details.type === 'product'")
                label.reader-show Comment
                textarea.block.w-full.border-b.py-15.md-py-6.px-10.text-app-text.placeholder-current.focus-placeholder-transp.focus-outline-none.bg-transp.resize-none.h-100(v-model="enquiry.caption", placeholder="Comment")
            //- submit
            .px-75.md-px-0.mt-60.flex.justify-center
              button.w-full.max-w-submit-btn.md-w-auto.md-min-w-btn.btn-theme-outlined(type="submit", :disabled="submitting", :class="{'opacity-50': submitting}")
                btn.w-full(type="submit", theme="inherit")
                  span(v-if="submitting") ...
                  span(v-else) Submit
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import Overlay from '@/components/Overlay'
import RespImg from '@/components/RespImg'
import Btn from '@/components/Btn'
export default {
  name: 'Enquire',
  props: {
    details: { type: Object, default: () => ({ }), required: true },
    type: { type: String, default: 'artwork' }
  },
  data () {
    return {
      enquiry: {
        first_name: '',
        last_name: '',
        email: '',
        tel: '',
        id: this.details.postId, // for retrieving custom email address
        ref: this.details.ref,
        img: this.details.thumb,
        caption: '',
        url: window.location.href
      },
      submitting: false,
      success: null,
      error: null
    }
  },
  methods: {
    reset () {
      this.success = this.error = null
    },
    submit () {
      this.submitting = true
      axios.post(Vue.config.WP.BMS + '/enquire', this.enquiry)
        .then(resp => {
          this.success = true
          this.submitting = false
        })
        .catch(err => {
          this.submitting = false
          this.error = err.response.data.help || "We're sorry, an error occured. Please try again."
        })
    },
    isPortrait (img) {
      return img && img.height > img.width
    }
  },
  mounted () {
    this.$nextTick(() => this.$el.focus())
  },
  components: { RespImg, Overlay, Btn }
}
</script>

<style>
</style>
